import React, { useEffect } from "react";

import { useSelector } from "react-redux";

// Hooks

import CheckPersonalReferenceOnLists from "../../../../hooks/CheckPersonalReferenceOnLists";

// Components

import TextInput from "../../../UI/FormInput/TextInput";
import MaskInput from "../../../UI/FormInput/MaskInput";
import DropDownInput from "../../../UI/FormInput/DropDownInput";
import FormInputGroup from "../../../UI/FormInputGroup/FormInputGroup";
import Button from "../../../UI/Button/Button";
import Alert from "../../../UI/Alert/Alert";

// Utilities

import { formatDropDownOptions } from "../../../../utilities/helper-functions";

// Constants

import {
  IDENTIFICATION_MASK_FORMAT,
  FULL_PHONE_MASK_FORMAT,
  PASSPORT_MASK_FORMAT,
} from "../../../../config/constants";

export default function PersonalReferenceFields({ formik, index }) {
  const {
    checkPersonalReferenceOnListIsLoading,
    checkPersonalReferenceOnListError,
    handleCheckPersonalReferenceOnLists,
  } = CheckPersonalReferenceOnLists();
  const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

  // Set if the reference is on a list

  const handleSetisOnList = (isOnList) => {
    formik.setFieldValue(`personalReferences.${index}.isOnList`, isOnList);
    formik.setFieldValue(`personalReferences.${index}.searchedOnList`, true);
  }

  // Check the reference on the lists

  const handleCheckReferenceOnList = () => {
    const internalListData = {
      DNI: formik.values?.personalReferences[index]?.tipoDocumento + formik.values?.personalReferences[index]?.cedulaReferencia,
    };

    const internationalListData = {
      nombre: formik.values?.personalReferences[index]?.nombre + " " + formik.values?.personalReferences[index]?.primerApellido + " " + formik.values?.personalReferences[index]?.segundoApellido,
      identifiacion: formik.values?.personalReferences[index]?.tipoDocumento + formik.values?.personalReferences[index]?.cedulaReferencia,
    };

    handleCheckPersonalReferenceOnLists(internalListData, internationalListData, handleSetisOnList);
  }


  // Get Bank Description by Code

  useEffect(() => {
    if (formik.values?.personalReferences[index]?.codParentesco) {
      const code = formik.values?.personalReferences[index]?.codParentesco;
      const item = dropDownOptions?.data?.relationships?.find(
        (item) => item.value === code
      );
      formik.setFieldValue(
        `personalReferences.${index}.parentesco`,
        item?.name
      );
    }
  }, [formik.values?.personalReferences[index]?.codParentesco]);

  return (
    <div key={index}>
      <h3 className="multiple-input-heading">
        Referencia personal{" "}
        {formik.values?.personalReferences?.length > 1 && index + 1}{" "}
      </h3>

      {checkPersonalReferenceOnListError &&
      <p className="form-error-message">Ocurrió un error al validar la referencia. Por favor reintente.</p>}

      {formik.values?.personalReferences[index]?.searchedOnList && formik.values?.personalReferences[index]?.isOnList &&
      <p className="form-error-message">Le invitamos a ingresar otra referencia personal.</p>}

      <FormInputGroup>
        <DropDownInput
          formik={formik}
          fieldName={`personalReferences.${index}.tipoDocumento`}
          label={"Tipo de Identificación"}
          options={formatDropDownOptions(dropDownOptions?.data?.identificationTypes)}
          isRequired={true}
          additionalFunctions={() => formik.setFieldValue(`personalReferences.${index}.searchedOnList`, false)}
          disabled={checkPersonalReferenceOnListIsLoading}
        />

        <MaskInput
          formik={formik}
          fieldName={`personalReferences.${index}.cedulaReferencia`}
          label={"Número de identificación"}
          mask={
            formik.values.personalReferences[index]?.tipoDocumento !== "P"
              ? IDENTIFICATION_MASK_FORMAT
              : PASSPORT_MASK_FORMAT
          }
          isRequired={true}
          additionalFunctions={() => formik.setFieldValue(`personalReferences.${index}.searchedOnList`, false)}
          disabled={checkPersonalReferenceOnListIsLoading}
        />

        <TextInput
          formik={formik}
          fieldName={`personalReferences.${index}.nombre`}
          label={"Nombres completos"}
          maxLength={42}
          isRequired={true}
          isAlphabetic
          disabled={checkPersonalReferenceOnListIsLoading}
          additionalFunctions={() => formik.setFieldValue(`personalReferences.${index}.searchedOnList`, false)}
        />

        <TextInput
          formik={formik}
          fieldName={`personalReferences.${index}.primerApellido`}
          label={"Primer apellido"}
          maxLength={20}
          isRequired={true}
          isAlphabetic
          disabled={checkPersonalReferenceOnListIsLoading}
          additionalFunctions={() => formik.setFieldValue(`personalReferences.${index}.searchedOnList`, false)}
        />

        <TextInput
          formik={formik}
          fieldName={`personalReferences.${index}.segundoApellido`}
          label={"Segundo apellido"}
          maxLength={20}
          isAlphabetic
          disabled={checkPersonalReferenceOnListIsLoading}
          additionalFunctions={() => formik.setFieldValue(`personalReferences.${index}.searchedOnList`, false)}
        />

        <DropDownInput
          formik={formik}
          fieldName={`personalReferences.${index}.codParentesco`}
          label={"Parentesco"}
          options={formatDropDownOptions(dropDownOptions?.data?.relationships)}
          isRequired={true}
          disabled={checkPersonalReferenceOnListIsLoading}
        />

        <MaskInput
          formik={formik}
          fieldName={`personalReferences.${index}.telefonoDomicilio`}
          label={"Teléfono Local (Línea Fija)"}
          mask={FULL_PHONE_MASK_FORMAT}
          disabled={checkPersonalReferenceOnListIsLoading}
        />

        <MaskInput
          formik={formik}
          fieldName={`personalReferences.${index}.telefonoOtro`}
          label={"Celular Móvil"}
          mask={FULL_PHONE_MASK_FORMAT}
          disabled={checkPersonalReferenceOnListIsLoading}
        />
      </FormInputGroup>

      {formik.values?.personalReferences[index]?.searchedOnList && !formik.values?.personalReferences[index]?.isOnList &&
      <Alert text={'Referencia validada exitosamente'} />}

      {!formik.values?.personalReferences[index]?.searchedOnList &&
      <div>

        <Button
          type="button"
          action={() => handleCheckReferenceOnList()}
          label={'Validar referencia'}
          additionalStyles={{marginLeft: 0, marginBottom: '2rem', padding: '0.75rem 1.5rem'}}
          isLoading={checkPersonalReferenceOnListIsLoading}
          disabled={
            !formik.values?.personalReferences[index]?.tipoDocumento ||
            !formik.values?.personalReferences[index]?.cedulaReferencia ||
            !formik.values?.personalReferences[index]?.nombre ||
            !formik.values?.personalReferences[index]?.primerApellido
          }
        />

        <span>Por favor complete los datos de la referencia para validar.</span>

      </div>}

    </div>
  );
}
